<script setup lang="ts">
import { computed } from 'vue';
import { useTranslation } from '@hfc/ui-core';
import { MenuItem } from '@/shared/domain/MenuItem';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

defineProps<{
  items: Array<MenuItem>
}>();

const { getBaseUrl, getCdnUrl } = useUrlHelper();
const { t } = useTranslation();

const getHref = computed(() => (menuItem: MenuItem): string => menuItem.isAbsolute ? menuItem.href : getBaseUrl(menuItem.href));

</script>
<template>
  <div v-if="items.length">
    <a v-for="item in items" @click="getHref(item)" :target="item.isBlank ? '_blank' : '_self'" :key="item.label" :href="getHref(item)" class="flex items-center whitespace-nowrap py-1 rounded-none font-light text-gray-500 md:text-blue-400 hover:text-blue hover:bg-gray-100 px-7">
      <img v-if="item.prefixImg" width="27" height="27" :src="`${getCdnUrl(item.prefixImg)}`" :alt="`${t(item.label)} icon`" class="mr-2" />
      {{ t(item.label) }}
    </a>
  </div>
</template>
